<form class="tw-w-full tw-h-fit tw-mb-4" [formGroup]="formGroup">
  <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-secondary tw-mb-1">{{ label | translate }} {{ isRequired ? "" : ("optional" | translate) }}</p>
  <div
    [ngClass]="widthLimited ? 'tw-max-w-72' : ''"
    [ngClass]="disabled ? 'tw-opacity-50' : ''"
    class="tw-w-full tw-h-12 tw-relative tw-flex tw-items-center tw-bg-white tw-border tw-border-grey-600 tw-rounded-[5px] tw-px-4 tw-py-3 tw-overflow-hidden"
  >
    <input
      [disabled]="disabled"
      [readonly]="disabled"
      [type]="type"
      [ngClass]="widthLimited ? 'tw-max-w-72' : ''"
      class="tw-flex-1 tw-bg-white tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-outline-none"
      [formControlName]="formControlName"
      [placeholder]="type == 'datetime-local' ? 'mm/dd/yyyy --:-- --' : (label | translate)"
    />
    <img *ngIf="originalType == 'password'" (click)="showHideField()" class="tw-w-5 tw-h-5 tw-object-contain tw-absolute tw-right-4" [src]="showHide" />
  </div>
  <div *ngIf="formGroup.get(formControlName).invalid && (formGroup.get(formControlName).touched || formGroup.get(formControlName).dirty)">
    <small *ngIf="formGroup.get(formControlName).errors['required']" class="tw-font-poppins tw-font-medium tw-text-xs tw-text-warning">{{ label | translate }} {{ "is-required" | translate }}</small>
    <small *ngIf="formGroup.get(formControlName).errors['pattern']" class="tw-font-poppins tw-font-medium tw-text-xs tw-text-warning">{{ label | translate }} {{ "is-not-valid" | translate }}</small>
  </div>
</form>
